export * from "modules/AppointmentDetails/components/ActivityLog/components/ActivityType";
